import { useEffect } from 'react';
import { API } from 'aws-amplify';

import {
  Flex,
  Heading,
  Text,
  View,
  useAuthenticator,
} from '@aws-amplify/ui-react';

import './billing.css';

export function Billing({ clientData, updateClientData, updateSubscription }) {

  var termsLink = 'https://growth.cool/terms';
  var privacyLink = 'https://growth.cool/privacy';
  var supportEmail = 'support@growth.cool';
  var backgroundColor = 'bg-dark-gray';
  var btnPrimaryClass="btn ui-gradient-peach shadow-md";
  var btnCancelClass="btn bg-dark-gray shadow-md";

  const hostname = window.location.hostname;

  if (hostname.indexOf('1st') > -1) {
    termsLink = 'https://www.1stinfluencer.com/terms-of-service';
    privacyLink = 'https://www.1stinfluencer.com/privacy-policy';
    supportEmail = 'info@1stinfluencer.com';
    backgroundColor = 'bg-[#0074e4]';
    btnPrimaryClass="mt-6 block rounded-md bg-[#0074e4] border-2 border-white px-3 py-2 text-center text-sm font-semibold text-white hover:bg-blue-400";
    btnCancelClass="mt-6 block rounded-md bg-dark-gray border-2 border-white px-3 py-2 text-center text-sm font-semibold text-white hover:bg-blue-400";
};

  const { user } = useAuthenticator((context) => [context.user]);
  const authToken = `${user.signInUserSession.idToken.jwtToken}`;
  //files from G.C/gc-backup/app-gc-backup-21-10-2022/js/
  useEffect(() => {
    const scripts = [
      './js/vendor/jquery-3.2.1.min.js',
      './js/jquery.payment.min.js',
      './js/vendor/bootstrap.min.js',
      './js/owl.carousel.min.js',
      './js/main.js'
    ];

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          // Script already exists in the DOM, resolve immediately
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    const loadScripts = async () => {
      try {
        for (let i = 0; i < scripts.length; i++) {
          await loadScript(scripts[i]);
        }

        (function ($) {
          var planId;
          var planTotal;

          if (clientData && (clientData.subscriptionPlan !== 'none')) {
            if (clientData && (clientData.payments === 'active')) {
                          /**/$('a#subscribe1').attr('disabled', true);
              $('a#subscribe2').attr('disabled', true);
              $('a#subscribe3').attr('disabled', true);
              $('a#subscribe4').attr('disabled', true);/**/
            } else {
                          /**/$('a#subscribe1').attr('disabled', false);
              $('a#subscribe2').attr('disabled', false);
              $('a#subscribe3').attr('disabled', false);
              $('a#subscribe4').attr('disabled', false);/**/
            };
            switch (clientData.subscriptionPlan) {
              case 'plus'://$8.9
                planTotal = 0;
                $('#planName').html('Plus');
                unsubscribeButton(clientData.subscriptionPlan, 'h3#unsubBtn');
                break;

                case 'test'://$39
                planTotal = 0;
                $('#planName').html('Test');
                unsubscribeButton(clientData.subscriptionPlan, 'h3#unsubBtn');
                break;

                case 'growth'://$59
                planTotal = 0;
                $('#planName').html('Growth');
                unsubscribeButton(clientData.subscriptionPlan, 'h3#unsubBtn');
                break;

              case 'lite':
                planTotal = 10;
                $('#planName').html('Lite');
                unsubscribeButton(clientData.subscriptionPlan, 'h3#unsubBtn');
                break;

              case 'pro':
                planTotal = 20;
                $('#planName').html('Pro');
                unsubscribeButton(clientData.subscriptionPlan, 'h3#unsubBtn');
                break;

              case 'basic-20-25':
                // code
                planTotal = 20;
                $('#planName').html('Lite');
                unsubscribeButton(clientData.subscriptionPlan, 'a#subscribe2');
                break;

              case 'standard-40-25':
                // code
                planTotal = 40;
                $('#planName').html('standard 1');
                unsubscribeButton(clientData.subscriptionPlan);
                break;

              case 'standard-20-50':
                // code
                planTotal = 20;
                $('#planName').html('PlusOld');
                unsubscribeButton(clientData.subscriptionPlan, 'a#subscribe4');
                break;

              case 'professional-60-25':
                // code
                planTotal = 20;
                $('#planName').html('Professional');
                // eslint-disable-next-line
                unsubscribeButton(clientData.subscriptionPlan, 'a#subscribe4');
                break;

              default:
                // code
                planTotal = 0;
                $('#planName').html('none');
            };
          } else { $('#planName').html('none'); planTotal = 2; };
          if (clientData && clientData.postBalance) { $('#postBalance').html(clientData.postBalance + '/' + planTotal); }
          else { $('#postBalance').html('0/' + planTotal); };
          if (clientData && clientData.postBalance) { $('#userEmail').html(clientData.email); }
          else { $('#userEmail').html(''); };


          function isValidUSZip(sZip) {
            return /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/i.test(sZip);
          };

          function unsubscribeButton(curPlanName, selectorName) {
            if ((!$('#unsubscribeButton').length) && (clientData && (clientData.payments === 'active'))) {
                var btn = document.createElement("a");
                btn.appendChild(document.createTextNode("UNSUBSCRIBE"));
                btn.setAttribute("href", "#unsubscribeModal");
                btn.setAttribute("data-toggle", "modal");
                btn.setAttribute("type", "button");
                btn.setAttribute("id", "unsubscribeButton");
                    btn.setAttribute(
                        "class",
                        btnPrimaryClass                        
                    );
                $(selectorName).parent().append(btn);
                // eslint-disable-next-line
                $("a#subscribe2").hide();
                $("a#subscribe3").hide();
                $("a#subscribe4").hide();
            } else {
              if (clientData && (clientData.payments !== 'active')) {
                $('a#unsubscribeButton').remove();
              }
            };
          };

          function handleSubscribeClick(event) {
            event.preventDefault();
            planId = $(this).attr('data-plan');
            if (clientData && (clientData.payments !== 'active')) {
              var planDesc = {
                'growth': 'Growth<br> $59 per month',
                'test': 'Test<br> $39 per month',
                'plus': 'Plus<br> $8.90 per month',
                'lite': 'Lite<br> $58.9 per month',
                'pro': 'Pro<br> $117.8 per month',
                'basic-20-25': 'Growth.Cool Lite<br> $25 per month',
                'standard-40-25': '<i><b>Standard 1</b></i> (89$/month)<br> 40 posts/month and 25 likes/post',
                'standard-20-50': 'Growth.Cool Plus<br> $49 per month',
                'professional-60-25': 'Growth.Cool Professional<br> $89 per month'
              };
              $('#planInfoPlace').html(planDesc[planId]);
              $('#paymentModal').modal('show')
            };// else if ( typeof(clientData) == "undefined") document.location.reload();
          }

          async function handleUnsubscribeConfirmedClick(event) {
            event.preventDefault();
            //start spinner and make submit disabled
            document.getElementById("overlay-processingU").style.display = "block";
            var unsubscribeParams = {
              headers: {
                Authorization: `${authToken}`
              },
              contentType: 'application/json',
              body: clientData
            };
            try {
              const dataUnsubscribe = await API.post("gcAPI", `/make-unsubscribe`, unsubscribeParams);
              //console.log(dataUnsubscribe);
              document.getElementById("overlay-processingU").style.display = "none";
              if (dataUnsubscribe.body.sub && (dataUnsubscribe.body.sub === 'cancelled')) {
                document.getElementById("overlay-successU").style.display = "block";
                let newClientData = JSON.parse(JSON.stringify(clientData));
                newClientData.payments = 'inactive';
                newClientData.subscriptionPlan = 'none';
                updateClientData(newClientData);
                $('a#subscribe2').show();
                $('a#subscribe3').show();
                $('a#subscribe4').show();
                //remove unsubscribe button node a#unsubscribeButton
                $('a#unsubscribeButton').remove();
              } else {
                $('#err-textU').html(dataUnsubscribe.body.dbu.message);
                //				console.log('error', result.body.dbu.message);
                document.getElementById("overlay-errorU").style.display = "block";
              };

              //dataUnsubscribe should contain sub object with new user data
              //so updateClientData(dataUnsubscribe.body. ... something)); should be here
              //so the page will show unsubscribe button on recently paid plan


            } catch (e) {
              document.getElementById("overlay-processingU").style.display = "none";
              document.getElementById("overlay-errorU").style.display = "block";
            };

          }

          $('#subscribe1').click(handleSubscribeClick);
          $('#subscribe2').click(handleSubscribeClick);
          $('#subscribe3').click(handleSubscribeClick);
          $('#subscribe4').click(handleSubscribeClick);
          $('#unsubscribeConfirmed').click(handleUnsubscribeConfirmedClick);

          $('#paymentModal').on('hidden.bs.modal', function (e) {
            document.getElementById("overlay-processing").style.display = "none";
            document.getElementById("overlay-success").style.display = "none";
            document.getElementById("overlay-error").style.display = "none";

            $('.cc-number').toggleClass('CheckoutInput--invalid', false);
            $('.cc-exp').toggleClass('CheckoutInput--invalid', false);
            $('.cc-cvc').toggleClass('CheckoutInput--invalid', false);
            $('.cc-zip').toggleClass('CheckoutInput--invalid', false);

          });

          $('#unsubscribeModal').on('hidden.bs.modal', function (e) {
            document.getElementById("overlay-processingU").style.display = "none";
            document.getElementById("overlay-successU").style.display = "none";
            document.getElementById("overlay-errorU").style.display = "none";
          });

          //start stripe validation
          $('[data-numeric]').payment('restrictNumeric');
          $('.cc-number').payment('formatCardNumber');
          $('.cc-exp').payment('formatCardExpiry');
          $('.cc-cvc').payment('formatCardCVC');
          $.fn.toggleInputError = function (erred) {
            this.toggleClass('CheckoutInput--invalid', erred);
            return this;
          };

          $('form').submit(async function (e) {
            e.preventDefault();
            var cardType = $.payment.cardType($('.cc-number').val());

            $('.cc-number').toggleInputError(!$.payment.validateCardNumber($('.cc-number').val()));
            $('.cc-exp').toggleInputError(!$.payment.validateCardExpiry($('.cc-exp').payment('cardExpiryVal')));
            $('.cc-cvc').toggleInputError(!$.payment.validateCardCVC($('.cc-cvc').val(), cardType));
            $('.cc-zip').toggleInputError(!isValidUSZip($('.cc-zip').val().toUpperCase()));

            if (!$('.CheckoutInput--invalid').length) {
              //start spinner and make submit disabled
              document.getElementById("overlay-processing").style.display = "block";

              var ccExp = $('.cc-exp').val().split(' / ');

              var paramsPayment = {
                number: $('.cc-number').val(),
                cvc: $('.cc-cvc').val(),
                expm: ccExp[0],
                expy: ccExp[1],
                zip: $('.cc-zip').val().toUpperCase()
              };

              var couponVal = $('#coupon').val();
              if (!couponVal || (couponVal.length > 30)) couponVal = '';
              //forever 99.99% off coupon

              //get firstpromoter cookie to send to make-subscription lambda
              var visitorTrackingId = document.cookie.match(new RegExp(`(^| )_fprom_track=([^;]+)`));
              if (visitorTrackingId) {
                visitorTrackingId = visitorTrackingId[2];
              } else { visitorTrackingId = '' };

              //get _ga cookie to send to make-subscription lambda
              var clientTrackingId = document.cookie.match(new RegExp(`(^| )_ga=([^;]+)`));
              if (clientTrackingId) {
                clientTrackingId = clientTrackingId[2].split('.'); clientTrackingId = clientTrackingId[2] + '.' + clientTrackingId[3];
              } else { clientTrackingId = '' };

              var subscribeParams = {
                headers: {
                  Authorization: `${authToken}`
                },
                contentType: 'application/json',
                body: { params: paramsPayment, email: clientData.email, planName: planId, coupon: couponVal, tid: visitorTrackingId, cid: clientTrackingId },

              };

              //              console.log("subscribeParams ", subscribeParams);
              try {
                const dataSubscribe = await API.post("gcAPI", `/make-subscription`, subscribeParams);
                //console.log("dataSubscribe ", dataSubscribe);
                document.getElementById("overlay-processing").style.display = "none";
                if (dataSubscribe.body.sub && (dataSubscribe.body.sub.status === 'active')) {
                  document.getElementById("overlay-success").style.display = "block";
                  //update client data
                  let newClientData = JSON.parse(JSON.stringify(clientData));
                  newClientData.payments = 'active';
                  newClientData.subscriptionPlan = planId;
                  newClientData.subscriptionId = dataSubscribe.body.sub.id;
                  newClientData.customerId = dataSubscribe.body.sub.customer;
                  updateClientData(newClientData);
                  updateSubscription(true);
                } else {
                  $('#err-text').html(dataSubscribe.body.dbu.message);
                  //console.log('error', result.body.dbu.message);
                  document.getElementById("overlay-error").style.display = "block";
                };

                //dataSubscribe should contain sub object with new user data
                //so updateClientData(dataSubscribe.body. ... something)); should be here
                //so the page will show unsubscribe button on recently paid plan

              } catch (e) {
                //console.log(e);
                //may be due to two cases:
                //- subscription success - this result is for waiting end
                //- 30 sec wait ended - no result yet
                //- some other error

                document.getElementById("overlay-processing").style.display = "none";
                document.getElementById("overlay-error").style.display = "block";
              };

            };
          });

        }(window.jQuery));


      } catch (error) {
        console.error('Error loading script:', error);
      }
    };

    loadScripts();

    return () => {
      scripts.forEach((src) => {
        const script = document.querySelector(`script[src="${src}"]`);
        if (script) {
          document.body.removeChild(script);
        }
      });
    };
    // eslint-disable-next-line
  }, [authToken, clientData]);

  const monthlyTiers = [
    {
        name: "FREE",
        price: "$0",
        sub: "per month",
        description:
            "• 2 test campaigns ($10 each)\n\n• Unlimited paid tasks for 1 profile\n\n• 0 targeted campaigns\n\n\n\n\n\n\n\n",
    },
    {
        name: "TEST",
        price: "$39",
        sub: "per month",
        description:
            "• 20 test campaigns ($10 each)\n\n• Unlimited paid tasks for 1 profile\n\n• 1 targeted campaign\n\n• $200 max campaign budget\n\n• Additional seats: OFF\n\n\n\n",
    },
    {
        name: "GROWTH",
        price: "$59",
        sub: "per month",
        description:
            "• 20 test campaigns ($10 each) per seat\n\n• Unlimited paid tasks for 1 profile\n\n• 1 profile per seat\n\n• 5 targeted campaigns per seat\n\n• $200 max campaign budget\n\n• Additional seats: $59/mo each\n\n",
    },
];

return (
    <View align="center">
        <Heading level={3} fontWeight={"bold"} textAlign="center">
            Billing
        </Heading>
        <View align="center">
            <Text variation="secondary">
                Select and update your monthly subscription
            </Text>
        </View>
        <View align="left" width={"70%"}>
            <Flex direction="row" gap="2rem" wrap="wrap">
                <View>
                    <Text variation="secondary">
                        <br />
                        {clientData &&
                        clientData.subscriptionPlan &&
                        clientData.subscriptionPlan === "none" ? (
                            <>
                                <b>CURRENT PLAN:</b> FREE - Includes free AI SMM
                                scheduler for your LinkedIn profile.
                                <br />
                                <b>NEXT CHARGE:</b> n/a
                            </>
                        ) : (
                            <>
                                <b>CURRENT PLAN:</b>{" "}
                                {clientData && clientData.subscriptionPlan
                                    ? clientData.subscriptionPlan.toUpperCase()
                                    : "loading..."}
                                <br />
                                
                                {clientData && clientData.nextCharge
                                    ? <><b>NEXT CHARGE:</b> clientData.nextCharge</>
                                    : <></>}
                                {clientData &&
                                clientData.subscriptionPlan &&
                                ["lite", "pro", "growth", "test"].includes(
                                    clientData.subscriptionPlan
                                ) && clientData && clientData.postBalance ? (
                                    <>
                                        <br />
                                        <b>CAMPAIGNS:</b>{" "}
                                        {clientData && clientData.postBalance
                                            ? clientData.postBalance
                                            : "loading..."}
                                    </>
                                ) : (
                                    <></>
                                )}
                            </>
                        )}
                    </Text>
                </View>
            </Flex>
        </View>
        <br />
        <br />
        <div className="container mx-auto px-4">
            {/* Display tiers based on current toggle */}
            <div className="isolate mx-auto grid max-w-md grid-cols-1 gap-8 sm:max-w-4xl lg:mx-0 lg:max-w-none lg:grid-cols-3">
                <div
                    key={monthlyTiers[0].name}
                    className={`rounded-3xl p-8 text-white ring-1 ring-white/10 ${backgroundColor} text-left`}
                >
                    <div className="flex justify-between">
                        <h3 className="text-lg font-semibold text-white">
                            {monthlyTiers[0].name}
                        </h3>
                    </div>

                    {/* If you want bullet points in the UI, use <ul><li>…</li></ul> or keep line breaks */}
                    <p className="mt-4 whitespace-pre-line text-sm text-white">
                        {monthlyTiers[0].description}
                    </p>

                    <p className="mt-6 flex items-baseline gap-x-1">
                        <span className="text-4xl font-semibold text-white">
                            {monthlyTiers[0].price}
                        </span>
                        <span className="text-sm font-semibold text-white">
                            {monthlyTiers[0].sub}
                        </span>
                    </p>
                    <br/><br/>
                    <View align="center">
                    {clientData &&
                    clientData.subscriptionPlan &&
                    clientData.subscriptionPlan === "none" ? (
                        <h3 id="unsubBtn" className='text-white'>CURRENT PLAN</h3>
                    ) : (
                        ""
                    )}
                    </View>
                </div>
                <div
                    key={monthlyTiers[1].name}
                    className={`rounded-3xl p-8 text-white ring-1 ring-white/10 ${backgroundColor} text-left`}
                >
                    <div className="flex justify-between">
                        <h3 className="text-lg font-semibold text-white">
                            {monthlyTiers[1].name}
                        </h3>
                    </div>

                    {/* If you want bullet points in the UI, use <ul><li>…</li></ul> or keep line breaks */}
                    <p className="mt-4 whitespace-pre-line text-sm text-white">
                        {monthlyTiers[1].description}
                    </p>

                    <p className="mt-6 flex items-baseline gap-x-1">
                        <span className="text-4xl font-semibold text-white">
                            {monthlyTiers[1].price}
                        </span>
                        <span className="text-sm font-semibold text-white">
                            {monthlyTiers[1].sub}
                        </span>
                    </p>
                    <br/><br/>
                    <View align="center">
                    {clientData &&
                    clientData.subscriptionPlan &&
                    clientData.subscriptionPlan === "test" ? (
                        <h3 id="unsubBtn">&nbsp;</h3>
                    ) : (
                        <></>
                    )}
                    {hostname.indexOf("1st") > -1 ? (
                        <a
                            href="#paymentModal"
                            className="mt-6 block rounded-md bg-[#0074e4] border-2 border-white px-3 py-2 text-center text-sm font-semibold text-white hover:bg-blue-400"
                            id="subscribe3"
                            data-plan="test"
                            data-toggle="modal"
                        >
                            GET STARTED
                        </a>
                    ) : (
                        <a
                            href="#paymentModal"
                            className="btn ui-gradient-peach shadow-md"
                            id="subscribe3"
                            data-plan="test"
                            data-toggle="modal"
                        >
                            Get started
                        </a>
                    )}
                    </View>
                </div>
                <div
                    key={monthlyTiers[2].name}
                    className={`rounded-3xl p-8 text-white ring-1 ring-white/10 ${backgroundColor} text-left`}
                >
                    <div className="flex justify-between">
                        <h3 className="text-lg font-semibold text-white">
                            {monthlyTiers[2].name}
                        </h3>
                    </div>

                    {/* If you want bullet points in the UI, use <ul><li>…</li></ul> or keep line breaks */}
                    <p className="mt-4 whitespace-pre-line text-sm text-white">
                        {monthlyTiers[2].description}
                    </p>

                    <p className="mt-6 flex items-baseline gap-x-1">
                        <span className="text-4xl font-semibold text-white">
                            {monthlyTiers[2].price}
                        </span>
                        <span className="text-sm font-semibold text-white">
                            {monthlyTiers[2].sub}
                        </span>
                    </p>
                    <br/><br/>
                    <View align="center">
                    {clientData &&
                    clientData.subscriptionPlan &&
                    clientData.subscriptionPlan === "growth" ? (
                        <h3 id="unsubBtn">&nbsp;</h3>
                    ) : (
                        <></>
                    )}
                    {hostname.indexOf("1st") > -1 ? (
                        <a
                            href="#paymentModal"
                            className="mt-6 block rounded-md bg-[#0074e4] border-2 border-white px-3 py-2 text-center text-sm font-semibold text-white hover:bg-blue-400"
                            id="subscribe4"
                            data-plan="growth"
                            data-toggle="modal"
                        >
                            GET STARTED
                        </a>
                    ) : (
                        <a
                            href="#paymentModal"
                            className="btn ui-gradient-peach shadow-md"
                            id="subscribe4"
                            data-plan="growth"
                            data-toggle="modal"
                        >
                            Get started
                        </a>
                    )}
                    </View>
                </div>
            </div>
        </div>

        <div
            id="paymentModal"
            className="modal fade"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="modalToken"
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="row">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <div
                                className="col-xs-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2"
                                id="coverWoverlay"
                            >
                                <p>&nbsp;</p>
                                <h3
                                    className="modal-title text-center"
                                    id="planInfoPlace"
                                >
                                    X
                                </h3>
                                <p>&nbsp;</p>

                                <form
                                    noValidate
                                    autoComplete="on"
                                    method="POST"
                                >
                                    <div className="PaymentForm-paymentMethodFormContainer flex-container spacing-16 direction-row wrap-wrap">
                                        <div className="flex-item width-12">
                                            <div className="FormFieldGroup">
                                                <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                                                    <label htmlFor="cardNumber-fieldset">
                                                        <span className="Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">
                                                            Card information
                                                        </span>
                                                    </label>
                                                </div>
                                                <div
                                                    className="FormFieldGroup-Fieldset"
                                                    id="cardNumber-fieldset"
                                                >
                                                    <div
                                                        className="FormFieldGroup-container"
                                                        id="cardNumber-fieldset"
                                                    >
                                                        <div className="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                                                            <div className="FormFieldInput">
                                                                <span
                                                                    className="InputContainer"
                                                                    data-max=""
                                                                >
                                                                    <input
                                                                        className="CheckoutInput CheckoutInput--tabularnums Input Input--empty cc-number"
                                                                        autoComplete="cc-number"
                                                                        autoCorrect="off"
                                                                        spellCheck="false"
                                                                        id="cardNumber"
                                                                        name="cardNumber"
                                                                        type="text"
                                                                        inputMode="numeric"
                                                                        aria-label="Card number"
                                                                        placeholder="1234 1234 1234 1234"
                                                                        aria-invalid="false"
                                                                        defaultValue=""
                                                                    />
                                                                </span>
                                                                <div
                                                                    className="FormFieldInput-Icons"
                                                                    style={{
                                                                        opacity:
                                                                            "1",
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            transform:
                                                                                "none",
                                                                        }}
                                                                    >
                                                                        <span className="FormFieldInput-IconsIcon is-visible">
                                                                            <img
                                                                                src="img/visa-365725566f9578a9589553aa9296d178.svg"
                                                                                alt="visa"
                                                                                className="BrandIcon"
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            transform:
                                                                                "none",
                                                                        }}
                                                                    >
                                                                        <span className="FormFieldInput-IconsIcon is-visible">
                                                                            <img
                                                                                src="img/mastercard-4d8844094130711885b5e41b28c9848f.svg"
                                                                                alt="mastercard"
                                                                                className="BrandIcon"
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                    {
                                                                        <div
                                                                            style={{
                                                                                transform:
                                                                                    "none",
                                                                            }}
                                                                        >
                                                                            <span className="FormFieldInput-IconsIcon is-visible">
                                                                                <img
                                                                                    src="img/amex-a49b82f46c5cd6a96a6e418a6ca1717c.svg"
                                                                                    alt="amex"
                                                                                    className="BrandIcon"
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    }
                                                                    <div className="CardFormFieldGroupIconOverflow">
                                                                        <span
                                                                            className="CardFormFieldGroupIconOverflow-Item CardFormFieldGroupIconOverflow-Item--invisible"
                                                                            role="presentation"
                                                                        >
                                                                            <span
                                                                                className="FormFieldInput-IconsIcon"
                                                                                role="presentation"
                                                                            >
                                                                                <img
                                                                                    src="img/discover-ac52cd46f89fa40a29a0bfb954e33173.svg"
                                                                                    alt="discover"
                                                                                    className="BrandIcon"
                                                                                />
                                                                            </span>
                                                                        </span>
                                                                        <span
                                                                            className="CardFormFieldGroupIconOverflow-Item CardFormFieldGroupIconOverflow-Item--visible"
                                                                            role="presentation"
                                                                        >
                                                                            <span
                                                                                className="FormFieldInput-IconsIcon"
                                                                                role="presentation"
                                                                            >
                                                                                <img
                                                                                    src="img/jcb-271fd06e6e7a2c52692ffa91a95fb64f.svg"
                                                                                    alt="jcb"
                                                                                    className="BrandIcon"
                                                                                />
                                                                            </span>
                                                                        </span>
                                                                        <span
                                                                            className="CardFormFieldGroupIconOverflow-Item CardFormFieldGroupIconOverflow-Item--invisible"
                                                                            role="presentation"
                                                                        >
                                                                            <span
                                                                                className="FormFieldInput-IconsIcon"
                                                                                role="presentation"
                                                                            >
                                                                                <img
                                                                                    src="img/diners-fbcbd3360f8e3f629cdaa80e93abdb8b.svg"
                                                                                    alt="diners"
                                                                                    className="BrandIcon"
                                                                                />
                                                                            </span>
                                                                        </span>
                                                                        <span
                                                                            className="CardFormFieldGroupIconOverflow-Item CardFormFieldGroupIconOverflow-Item--invisible"
                                                                            role="presentation"
                                                                        >
                                                                            <span
                                                                                className="FormFieldInput-IconsIcon"
                                                                                role="presentation"
                                                                            ></span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="FormFieldGroup-child FormFieldGroup-child--width-6 FormFieldGroup-childLeft FormFieldGroup-childBottom">
                                                            <div className="FormFieldInput">
                                                                <span
                                                                    className="InputContainer"
                                                                    data-max=""
                                                                >
                                                                    <input
                                                                        className="CheckoutInput CheckoutInput--tabularnums Input Input--empty cc-exp"
                                                                        autoComplete="cc-exp"
                                                                        autoCorrect="off"
                                                                        spellCheck="false"
                                                                        id="cardExpiry"
                                                                        name="cardExpiry"
                                                                        type="text"
                                                                        inputMode="numeric"
                                                                        aria-label="Expiration"
                                                                        placeholder="MM / YY"
                                                                        aria-invalid="false"
                                                                        defaultValue=""
                                                                    />
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="FormFieldGroup-child FormFieldGroup-child--width-6 FormFieldGroup-childRight FormFieldGroup-childBottom">
                                                            <div className="FormFieldInput has-icon">
                                                                <span
                                                                    className="InputContainer"
                                                                    data-max=""
                                                                >
                                                                    <input
                                                                        className="CheckoutInput CheckoutInput--tabularnums Input Input--empty cc-cvc"
                                                                        autoComplete="cc-csc"
                                                                        autoCorrect="off"
                                                                        spellCheck="false"
                                                                        id="cardCvc"
                                                                        name="cardCvc"
                                                                        type="text"
                                                                        inputMode="numeric"
                                                                        aria-label="CVC"
                                                                        placeholder="CVC"
                                                                        aria-invalid="false"
                                                                        defaultValue=""
                                                                    />
                                                                </span>
                                                                <div className="FormFieldInput-Icon is-loaded">
                                                                    <svg
                                                                        className="Icon Icon--md"
                                                                        focusable="false"
                                                                        viewBox="0 0 32 21"
                                                                    >
                                                                        <g
                                                                            fill="none"
                                                                            fillRule="evenodd"
                                                                        >
                                                                            <g className="Icon-fill">
                                                                                <g transform="translate(0 2)">
                                                                                    <path
                                                                                        d="M21.68 0H2c-.92 0-2 1.06-2 2v15c0 .94 1.08 2 2 2h25c.92 0 2-1.06 2-2V9.47a5.98 5.98 0 0 1-3 1.45V11c0 .66-.36 1-1 1H3c-.64 0-1-.34-1-1v-1c0-.66.36-1 1-1h17.53a5.98 5.98 0 0 1 1.15-9z"
                                                                                        opacity=".2"
                                                                                    ></path>
                                                                                    <path
                                                                                        d="M19.34 3H0v3h19.08a6.04 6.04 0 0 1 .26-3z"
                                                                                        opacity=".3"
                                                                                    ></path>
                                                                                </g>
                                                                                <g transform="translate(18)">
                                                                                    <path d="M7 14A7 7 0 1 1 7 0a7 7 0 0 1 0 14zM4.22 4.1h-.79l-1.93.98v1l1.53-.8V9.9h1.2V4.1zm2.3.8c.57 0 .97.32.97.78 0 .5-.47.85-1.15.85h-.3v.85h.36c.72 0 1.21.36 1.21.88 0 .5-.48.84-1.16.84-.5 0-1-.16-1.52-.47v1c.56.24 1.12.37 1.67.37 1.31 0 2.21-.67 2.21-1.64 0-.68-.42-1.23-1.12-1.45.6-.2.99-.73.99-1.33C8.68 4.64 7.85 4 6.65 4a4 4 0 0 0-1.57.34v.98c.48-.27.97-.42 1.44-.42zm4.32 2.18c.73 0 1.24.43 1.24.99 0 .59-.51 1-1.24 1-.44 0-.9-.14-1.37-.43v1.03c.49.22.99.33 1.48.33.26 0 .5-.04.73-.1.52-.85.82-1.83.82-2.88l-.02-.42a2.3 2.3 0 0 0-1.23-.32c-.18 0-.37.01-.57.04v-1.3h1.44a5.62 5.62 0 0 0-.46-.92H9.64v3.15c.4-.1.8-.17 1.2-.17z"></path>
                                                                                </g>
                                                                            </g>
                                                                        </g>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            style={{
                                                                opacity: "0",
                                                                height: "0px",
                                                            }}
                                                        >
                                                            <span className="FieldError Text Text-color--red Text-fontSize--13">
                                                                <span aria-hidden="true"></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="billing-container flex-item width-12"
                                            aria-hidden="false"
                                        >
                                            <div
                                                style={{
                                                    pointerEvents: "auto",
                                                    height: "auto",
                                                    opacity: "1",
                                                }}
                                            >
                                                <div className="flex-container spacing-16 direction-row wrap-wrap">
                                                    <div className="flex-item width-12">
                                                        <div className="FormFieldGroup">
                                                            <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                                                                <label htmlFor="country-fieldset">
                                                                    <span className="Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">
                                                                        Postal
                                                                        code
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <fieldset
                                                                className="FormFieldGroup-Fieldset"
                                                                id="country-fieldset"
                                                            >
                                                                <div
                                                                    className="FormFieldGroup-container FormFieldGroup-container--supportTransitions"
                                                                    id="country-fieldset"
                                                                >
                                                                    <div
                                                                        className="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childBottom"
                                                                        style={{
                                                                            height: "38px",
                                                                            transform:
                                                                                "none",
                                                                        }}
                                                                    >
                                                                        <div className="FormFieldInput">
                                                                            <span
                                                                                className="InputContainer"
                                                                                data-max=""
                                                                            >
                                                                                <input
                                                                                    className="CheckoutInput CheckoutInput--tabularnums Input Input--empty cc-zip"
                                                                                    autoComplete="billing postal-code"
                                                                                    autoCorrect="off"
                                                                                    spellCheck="false"
                                                                                    id="billingPostalCode"
                                                                                    name="billingPostalCode"
                                                                                    type="text"
                                                                                    inputMode="numeric"
                                                                                    aria-label="ZIP"
                                                                                    placeholder="ZIP"
                                                                                    aria-invalid="false"
                                                                                    defaultValue=""
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            opacity:
                                                                                "0",
                                                                            height: "0px",
                                                                        }}
                                                                    >
                                                                        <span className="FieldError Text Text-color--red Text-fontSize--13">
                                                                            <span aria-hidden="true"></span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </fieldset>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-item width-12"></div>
                                        <div className="flex-item width-12">
                                            <button
                                                className="SubmitButton SubmitButton--incomplete"
                                                type="submit"
                                                style={{
                                                    backgroundColor: "#343145",
                                                    color: "#ffffff",
                                                }}
                                            >
                                                <div
                                                    className="SubmitButton-Shimmer"
                                                    style={{
                                                        background:
                                                            "linear-gradient(to right, rgba(52, 49, 69, 0) 0%, rgb(72, 69, 90) 50%, rgba(52, 49, 69, 0) 100%)",
                                                    }}
                                                ></div>
                                                <div className="SubmitButton-TextContainer">
                                                    <span
                                                        className="SubmitButton-Text SubmitButton-Text--current Text Text-color--default Text-fontWeight--500 Text--truncate"
                                                        aria-hidden="false"
                                                    >
                                                        Subscribe
                                                    </span>
                                                    <span
                                                        className="SubmitButton-Text SubmitButton-Text--pre Text Text-color--default Text-fontWeight--500 Text--truncate"
                                                        aria-hidden="true"
                                                    >
                                                        Processing...
                                                    </span>
                                                </div>
                                                <div className="SubmitButton-IconContainer">
                                                    <div className="SubmitButton-Icon SubmitButton-Icon--pre">
                                                        <div className="Icon Icon--md Icon--square">
                                                            <svg
                                                                viewBox="0 0 16 16"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                focusable="false"
                                                            >
                                                                <path
                                                                    d="M3 7V5a5 5 0 1 1 10 0v2h.5a1 1 0 0 1 1 1v6a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V8a1 1 0 0 1 1-1zm5 2.5a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zM11 7V5a3 3 0 1 0-6 0v2z"
                                                                    fill="#ffffff"
                                                                    fillRule="evenodd"
                                                                ></path>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <div className="SubmitButton-Icon SubmitButton-SpinnerIcon SubmitButton-Icon--pre">
                                                        <div className="Icon Icon--md Icon--square">
                                                            <svg
                                                                viewBox="0 0 24 24"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                focusable="false"
                                                            >
                                                                <ellipse
                                                                    cx="12"
                                                                    cy="12"
                                                                    rx="10"
                                                                    ry="10"
                                                                    style={{
                                                                        stroke: "rgb(255, 255, 255)",
                                                                    }}
                                                                ></ellipse>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="SubmitButton-CheckmarkIcon">
                                                    <div className="Icon Icon--md">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="22"
                                                            height="14"
                                                            focusable="false"
                                                        >
                                                            <path
                                                                d="M 0.5 6 L 8 13.5 L 21.5 0"
                                                                fill="transparent"
                                                                strokeWidth="2"
                                                                stroke="#ffffff"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </button>
                                            <div className="ConfirmPayment-PostSubmit">
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                <p
                                    className="text-center"
                                    style={{ fontSize: "smaller" }}
                                >
                                    By confirming your subscription, you allow{" "}
                                    {window.location.hostname} to charge your
                                    card for this payment and future payments in
                                    accordance with their terms.
                                </p>
                                <p>&nbsp;</p>
                                <p
                                    className="text-center"
                                    style={{ fontSize: "smaller" }}
                                >
                                    <a
                                        href={termsLink}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <u style={{ color: "#708198" }}>
                                            Terms
                                        </u>
                                    </a>{" "}
                                    |{" "}
                                    <a
                                        href={privacyLink}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <u style={{ color: "#708198" }}>
                                            Privacy
                                        </u>
                                    </a>
                                </p>

                                <div id="overlay-processing">
                                    <div id="text-processing">
                                        <i className="fa fa-cog fa-spin"></i>
                                        <br />
                                        Processing
                                    </div>
                                </div>

                                <div id="overlay-success">
                                    <div id="text-processing">Success!</div>
                                    <div id="text-processing2">
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                    </div>
                                </div>

                                <div id="overlay-error">
                                    <div id="text-processing">Error</div>
                                    <div
                                        id="text-processing2"
                                        style={{ width: "68%" }}
                                    >
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <div id="err-text"></div>
                                        <br />
                                        Try again, please!
                                        <br />
                                        <br />
                                        <b>For all non-US customers:</b>
                                        <br />
                                        <font>
                                            ask for payment link at{" "}
                                            {supportEmail}
                                        </font>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            id="unsubscribeModal"
            className="modal fade"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="modalTokenU"
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div className="row" id="coverWoverlay">
                            <div className="col-xs-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2">
                                <br />
                                <h4
                                    className="modal-title text-center"
                                    id="myModalLabel"
                                >
                                    CONFIRM CANCELLING SUBSCRIPTION:
                                </h4>
                                <br />
                                <br />
                            </div>
                            <div className="col-xs-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2">
                                <b>
                                    Subscription to be cancelled immediately -
                                    you won't be charged any more.
                                    <br />
                                    <br />
                                    Your current campaigns balance will be
                                    nulled and you won't be able to boost posts
                                    until re-subscribing.
                                    <br />
                                    <br />
                                    {/*Your current balance won't be affected and you may keep boosting posts until balance is not 0.*/}
                                </b>
                                <br />
                                <br />
                                <br />
                                <br />
                            </div>
                            <div className="col-xs-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2 text-center">
                                <Flex direction="row" gap="2rem" wrap="wrap" className="justify-content-center">
                                <button
                                    href="#"
                                    className={btnPrimaryClass}
                                    data-dismiss="modal"
                                >
                                    DISMISS
                                </button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <button
                                    href="#"
                                    id="unsubscribeConfirmed"
                                    className={btnCancelClass}
                                >
                                    UNSUBSCRIBE
                                </button>
                                </Flex>
                                <br />
                                <br />
                            </div>

                            <div id="overlay-processingU">
                                <div id="text-processing">
                                    <i className="fa fa-cog fa-spin"></i>
                                    <br />
                                    Processing
                                </div>
                            </div>

                            <div id="overlay-successU">
                                <div id="text-processing">Success!</div>
                                <div id="text-processing2">
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            </div>

                            <div id="overlay-errorU">
                                <div id="text-processing">Error</div>
                                <div
                                    id="text-processing2"
                                    style={{ width: "68%" }}
                                >
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <div
                                        id="err-textU"
                                        style={{ color: "red" }}
                                    ></div>
                                    <br />
                                    Try again, please!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </View>
);
}